import { Draft, Update } from '@reduxjs/toolkit'

import { CheckOrderTicketEntity, OrderReducerState } from '../types'
import { checkOrderTicketsEntityAdapter } from '../store/ordersEntityAdapter'

import getCheckOrderTicketMinimumItemStatus from './getCheckOrderTicketMinimumItemStatus'
import getTicketStatusOfItemStatus from './getTicketStatusOfItemStatus'

const checkOrderTicketsEntityAdapterSelectors =
  checkOrderTicketsEntityAdapter.getSelectors()

/**
 * This can be invoked to sync the status of the ticket after any update of ticket items.
 * Multiple tickets update is supported.
 */
function updateTicketStatusFromItemsStatus(
  state: Draft<OrderReducerState>,
  ticketIds: string[],
) {
  const updates = ticketIds.reduce<Update<CheckOrderTicketEntity, string>[]>(
    (acc, ticketId) => {
      const ticketEntity = checkOrderTicketsEntityAdapterSelectors.selectById(
        state.checkOrderSummaryTickets,
        ticketId,
      )

      if (ticketEntity) {
        const minimumTicketItemStatus =
          getCheckOrderTicketMinimumItemStatus(ticketEntity)

        if (minimumTicketItemStatus !== undefined) {
          const ticketStatus = getTicketStatusOfItemStatus(
            minimumTicketItemStatus,
          )

          if (ticketStatus > ticketEntity.status) {
            acc.push({
              id: ticketId,
              changes: {
                status: ticketStatus,
              },
            })
          }
        }
      }

      return acc
    },
    [],
  )

  if (updates.length > 0) {
    if (updates.length === 1) {
      checkOrderTicketsEntityAdapter.updateOne(
        state.checkOrderSummaryTickets,
        updates[0],
      )
    } else {
      checkOrderTicketsEntityAdapter.updateMany(
        state.checkOrderSummaryTickets,
        updates,
      )
    }
  }
}

export default updateTicketStatusFromItemsStatus
